import { TableColumns } from '@ohpen/enso-ui';
import { FieldType, ImportResult } from '@pmp/api';

export const columns: TableColumns<ImportResult> = [
  {
    title: 'pmp.products.labels.createdAt',
    dataIndex: 'creationTime',
    key: 'creationTime',
    options: {
      format: {
        type: 'dateTimeLocal',
      },
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'global.labels.entityType',
    dataIndex: 'importEntityType',
    key: 'entityType',
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.ACTION_ENTITY_TYPE,
    },
  },
  {
    title: 'pmp.products.labels.createdBy',
    dataIndex: 'createdBy',
    key: 'createdBy',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  { title: 'global.labels.actions', dataIndex: '', key: 'actions', width: 120, fixed: 'right' },
];
